<template>
  <div ref="cell" class="grid-view__cell grid-field-barcode__cell">
    <div class="grid-field-barcode">
      <BarcodeCanvas
        :value="resolvedSourceValue"
        :format="field.barcode_format"
        :height="28"
      />
    </div>
  </div>
</template>

<script>
import sourceFieldReferenceField from '@baserow/modules/database/mixins/sourceFieldReferenceField'
import BarcodeCanvas from '@baserow/modules/database/components/field/BarcodeCanvas'

export default {
  name: 'FunctionalGridViewFieldBarcode',
  components: { BarcodeCanvas },
  // No `gridField`/`gridFieldInput` mixin here: those wire up selection and
  // editing interactions, but this field is never selected for editing --
  // it's rendered read-only in the "functional" (non-interactive) cell
  // variant, the same reasoning as FunctionalGridViewFieldButtonField.
  mixins: [sourceFieldReferenceField],
  props: {
    row: { type: Object, required: true },
    field: { type: Object, required: true },
    // Present on the props contract for parity with other functional cells,
    // but unused: this field has no stored value of its own to receive.
    value: { type: null, default: null },
  },
}
</script>
